import React, { memo, useCallback } from 'react';

import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';

const SelectedOption = ({ option, onRemove }) => {
  const handleRemove = useCallback(() => {
    onRemove(option);
  }, [option, onRemove]);

  return (
    <div className='multiselect_selected-option'>
      {option.label}
      <Icon
        icon={ICONS.Cross}
        disableCommonStyles
        disableCommonColors
        className='multiselect_selected-option_close-icon'
        onClick={handleRemove}
      />
    </div>
  );
};

export default memo(SelectedOption);
